import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";
import "swiper/css/effect-coverflow";
import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard,
  EffectCoverflow,
  Grid,
} from "swiper";

import { useTheme, useMediaQuery } from "@mui/material";
import GameCard from "../Game/GameCard";
import Image from "./Image";
import * as Constant from "../../features/constant";
const CardCarousel = ({
  data,
  slidesPerView,
  spaceBetween,
  effect,
  pagination,
  style,
  imageHeight,
  imageWidth,
  navigation,
  rows,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <>
      <Swiper
        effect={effect}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        style={{
          "--swiper-pagination-color": theme.palette.primary.main,
          "--swiper-pagination-bullet-size": "10px",
          "--swiper-navigation-color": theme.palette.primary.main,
        }}
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        grid={{
          rows: rows,
          fill: "row",
        }}
        navigation={navigation}
        pagination={pagination ? { clickable: true } : pagination}
        mousewheel={false}
        keyboard={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[
          Autoplay,
          Grid,
          Navigation,
          Pagination,
          Mousewheel,
          Keyboard,
          EffectCoverflow,
        ]}
      >
        {data?.result?.map((item, index) => {
          return (
            <SwiperSlide
              key={index}
              style={{
                width: "fit-content",
              }}
            >
              <GameCard
                imageUrl={item?.thumbnailUrl}
                imageHeight={imageHeight}
                imageWidth={imageWidth}
                isHotGame={true}
                onClick={() => {
                  navigate(Constant.getPath("/game/" + item.categoryCode?.toLowerCase()), {
                    state: {
                      providerId: item.providerId,
                    },
                  });
                }}
                title={item?.name}
                alt={Constant.ALT_TAG_GENERAL_GAME + item.name}
                subtitle={
                  data?.allGameProvider?.find(
                    (provider) => provider?.id === item?.providerId
                  )?.name
                }
                description={{}}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

CardCarousel.propTypes = {
  data: PropTypes.array,
  slidesPerView: PropTypes.number,
  spaceBetween: PropTypes.number,
  effect: PropTypes.string,
  pagination: PropTypes.bool,
  style: PropTypes.object,
  onClick: PropTypes.func,
  type: PropTypes.string,
  navigation: PropTypes.bool,
  rows: PropTypes.number,
};

CardCarousel.defaultProps = {
  data: [],
  slidesPerView: 1,
  spaceBetween: 20,
  effect: null,
  pagination: true,
  style: {
    "--swiper-navigation-color": "#FFF",
    "--swiper-navigation-size": "40px",
    "--swiper-pagination-color": "#FFF",
  },
  onClick: () => null,
  type: null,
  navigation: true,
  rows: 1,
};

export default CardCarousel;
